import { Component, ViewChild, viewChild } from '@angular/core';
import {HeaderComponent} from "src/app/pages/customer/common/header/header.component";
import {FooterComponent} from "src/app/pages/public/common/footer/footer.component";
import {RouterOutlet} from "@angular/router";
import { ModalsComponent } from "../../../common/modals/modals.component";
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { ToastComponent } from 'src/app/common/toast/toast.component';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { LoginModalComponent } from 'src/app/common/login-modal/login-modal.component';
import { LoginModalService } from 'src/app/services/LoginModal/login-modal.service';
import { ScrollToTopComponent } from 'src/app/common/scroll-to-top/scroll-to-top.component';

@Component({
    selector: 'public-template',
    imports: [
        HeaderComponent,
        FooterComponent,
        RouterOutlet,
        ModalsComponent,
        ToastComponent,
        LoginModalComponent,
        ScrollToTopComponent
    ],
    templateUrl: './template.component.html',
    styleUrl: './template.component.scss'
})
export class TemplateComponent {
  @ViewChild('modals',{static: true}) modals!: ModalsComponent;
  @ViewChild('toast',{ static: true }) toasts!: ToastComponent;
  @ViewChild('login_modal',{ static: true }) loginModalComponent!: LoginModalComponent;

  constructor(
    private modalService: ModalsService,
    private toastService: ToastService,
    private loginModal: LoginModalService,
  ){}
  
  ngOnInit(){
    this.modalService.bindComponent(this.modals);
    this.toastService.bindComponent(this.toasts);
    this.loginModal.bindComponent(this.loginModalComponent);

  }
}
